import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import PlanSelectionComponent from './PlanSelectionComponent'
import BarSelectionComponent from './BarSelectionComponent'
function TabContainer({ className, children }) {
  return (
    <Grid className={className} item>
      {children}
    </Grid>
  )
}
TabContainer.propTypes = {
  className: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
}
TabContainer.propTypes = {
  children: PropTypes.node.isRequired
}

const styles = theme => ({
  container: {
    borderRadius: '5px',
    overflow: 'hidden',
    height: 'calc(100%)'
  },
  rootTabs: {
    width: '100%',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    height: 51
  },
  scrollContainer: {
    overflow: 'scroll',
    width: 'calc(100%)',
    height: 'calc(100%)',
    minHeight: '200px'
  },
  rootTab: {
    height: 51,
    maxWidth: 'none'
  }
})
class SelectionTabsComponent extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    tables: PropTypes.array.isRequired,
    bars: PropTypes.array.isRequired,
    map: PropTypes.object.isRequired,
    onSelect: PropTypes.func.isRequired,
    currentTransaction: PropTypes.object
  }

  state = {
    tabValue: 0,
    selectedTable: void 0,
    selectedBar: void 0
  }
  componentWillReceiveProps(nextProps) {}
  componentDidMount() {}
  handleSelectBar = bar => {
    if (bar) {
      this.setState({ selectedTable: void 0, selectedBar: bar })
      if (this.props.currentTransaction) {
        this.props.onSelect(bar)
      } else {
        this.props.onSelect(bar.currentTransaction)
      }
    }
  }
  handleSelectTable = table => {
    if (table) {
      this.setState({ selectedTable: table, selectedBar: void 0 })
      if (this.props.currentTransaction) {
        this.props.onSelect(table)
      } else {
        this.props.onSelect(table.currentTransaction)
      }
    }
  }
  handleChange = (event, value) => {
    this.setState({ tabValue: value })
  }
  render() {
    const { classes, tables, bars, currentTransaction } = this.props
    const { tabValue } = this.state
    return (
      <Paper className={classes.container} elevation={3}>
        <Tabs
          className={classes.rootTabs}
          value={tabValue}
          onChange={this.handleChange}
          fullWidth
          centered
          scrollButtons="off"
          indicatorColor="secondary">
          <Tab className={classes.rootTab} label="Billard" />
          <Tab className={classes.rootTab} label="Bar" />
          {/* <Tab className={classes.rootTab} label="Clients" /> */}
        </Tabs>
        {tabValue === 0 && (
          <TabContainer className={classes.scrollContainer}>
            <PlanSelectionComponent
              selectedTable={this.state.selectedTable}
              onTableSelection={this.handleSelectTable}
              tables={tables}
              map={this.props.map}
              currentTransaction={currentTransaction}
            />
          </TabContainer>
        )}
        {tabValue === 1 && (
          <TabContainer className={classes.scrollContainer}>
            <BarSelectionComponent
              bars={bars}
              selectedBar={this.state.selectedBar}
              onBarSelection={this.handleSelectBar}
              currentTransaction={currentTransaction}
            />
          </TabContainer>
        )}
      </Paper>
    )
  }
}
const mapStateToProps = state => {
  return {
    tables: state.tables.list,
    bars: state.bars.list,
    map: state.settings.size
  }
}

export default connect(mapStateToProps, {})(
  withStyles(styles, { withTheme: true })(SelectionTabsComponent)
)



// WEBPACK FOOTER //
// ./src/components/SelectionTabsComponent/SelectionTabsComponent.js